import {
	Model,
	PurchaseOrderError,
	YardSchedule,
	YardTrip
} from ".";

export default class PurchaseOrder extends Model {
	get singularNoun() {
		return "purchase order";
	}

	get mutations() {
		return {
			errors: PurchaseOrderError,
			schedules: YardSchedule,
			trips: YardTrip
		};
	}

	resource() {
		return "sales/purchase-orders";
	}
}
